import { render } from "./AppSetting.vue?vue&type=template&id=55a0efbb&scoped=true"
import script from "./AppSetting.vue?vue&type=script&lang=js"
export * from "./AppSetting.vue?vue&type=script&lang=js"

import "./AppSetting.vue?vue&type=style&index=0&id=55a0efbb&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-55a0efbb"

export default script